import { render, staticRenderFns } from "./area-select.vue?vue&type=template&id=39f70694&"
import script from "./area-select.vue?vue&type=script&lang=ts&"
export * from "./area-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports